import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface BankInfoFormIF {
  financialFacilityCode: string;
  financialFacilityName: string;
  branchCord: string;
  branchName: string;
  bankType: string;
  bankNumber: string;
  bankAccountKana: string;
  paymentCycleSelect: string;
  //加盟店保有銀行口座YES=1/NO=0
  textAns: boolean;
  corpNumber?: string;
  companyName?: string;
  companyNameKana?: string;
  postalCode?: string;
  prefectures?: string;
  city?: string;
  area?: string;
  koazaChome?: string;
  banchi?: string;
  buildingName?: string;
  phoneNumber?: string;
}

const initialState = {} as BankInfoFormIF;

const bankInfoFormConditionSlice = createSlice({
  name: "bankInfoForm",
  initialState,
  reducers: {
    bankAccountRegist: (
      state,
      action: PayloadAction<{
        financialFacilityCode: string;
        financialFacilityName: string;
        branchCord: string;
        branchName: string;
        bankType: string;
        bankNumber: string;
        bankAccountKana: string;
        paymentCycleSelect: string;
        //加盟店保有銀行口座YES=1/NO=0
        textAns: boolean;
        corpNumber?: string;
        companyName?: string;
        companyNameKana?: string;
        postalCode?: string;
        prefectures?: string;
        city?: string;
        area?: string;
        koazaChome?: string;
        banchi?: string;
        buildingName?: string;
        phoneNumber?: string;
      }>
    ) => {
      const {
        financialFacilityCode,
        financialFacilityName,
        branchCord,
        branchName,
        bankType,
        bankNumber,
        bankAccountKana,
        paymentCycleSelect,
        textAns,
        corpNumber,
        companyName,
        companyNameKana,
        postalCode,
        prefectures,
        city,
        area,
        koazaChome,
        banchi,
        buildingName,
        phoneNumber,
      } = action.payload;
      state.financialFacilityCode = financialFacilityCode;
      state.financialFacilityName = financialFacilityName;
      state.branchCord = branchCord;
      state.branchName = branchName;
      state.bankType = bankType;
      state.bankNumber = bankNumber;
      state.bankAccountKana = bankAccountKana;
      state.paymentCycleSelect = paymentCycleSelect;
      state.textAns = textAns;
      state.corpNumber = corpNumber;
      state.companyName = companyName;
      state.companyNameKana = companyNameKana;
      state.postalCode = postalCode;
      state.prefectures = prefectures;
      state.city = city;
      state.area = area;
      state.koazaChome = koazaChome;
      state.banchi = banchi;
      state.buildingName = buildingName;
      state.phoneNumber = phoneNumber;
    },
  },
});

export const { bankAccountRegist } = bankInfoFormConditionSlice.actions;

export default bankInfoFormConditionSlice.reducer;
